<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage job cards</div>
            <fieldset class="border p-3">
              <div></div>
              <div class="jobcardsLoader">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i
                  class="fa fa-spinner fa-spin"
                  style="font-size: 24px; color: blue"
                ></i
                >loading jobcards...
              </div>
              <vue-good-table
                :columns="columns"
                :rows="systemJobcards"
                :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 6,
                  position: 'bottom',
                  perPageDropdown: [3, 7, 9],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Status'">
                    <span v-if="props.row.status === 0">
                      <button class="btn btn-danger btn-sm btn-flat">
                        <i class="fa fa-gear"></i> NOT CLEARED
                      </button>
                    </span>
                    <span v-else-if="props.row.status === 1">
                      <button class="btn btn-success btn-sm">
                        <i class="fa fa-check"></i> CLEARED
                      </button>
                    </span>
                  </span>
                  <span v-else-if="props.column.field == 'Sale'">
                    <span v-if="props.row.status === 0">
                      <button
                        class="btn btn-primary btn-sm btn-flat"
                        @click="viewJobcard(props.row.id)"
                      >
                        <i class="fa fa-plus"></i> Add Truck sale
                      </button>
                    </span>
                    <span v-else-if="props.row.status === 1">
                      <button class="btn btn-success btn-sm">
                        <i class="fa fa-check"></i> CLEARED
                      </button>
                    </span>
                  </span>

                  <span v-else-if="props.column.field == 'Labour'">
                    <span v-if="props.row.status === 0">
                      <button
                        class="btn btn-primary btn-sm btn-flat"
                        @click="addJoblabour(props.row.id)"
                      >
                        <i class="fa fa-plus"></i> Add Truck Labour
                      </button>
                    </span>
                    <span v-else-if="props.row.status === 1">
                      <button class="btn btn-success btn-sm">
                        <i class="fa fa-check"></i> CLEARED
                      </button>
                    </span>
                  </span>
                  <span v-else-if="props.column.field == 'View'">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="viewjobcardsales(props.row.id)"
                    >
                      <i class="fa fa-file-pdf-o"></i> VIEW
                    </button>
                  </span>
                </template>
              </vue-good-table>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Job card no",
          field: "job_card_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter number",
          },
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "status",
          field: "Status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Date",
          field: "job_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Sale",
          field: "Sale",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Labour",
          field: "Labour",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "View",
          field: "View",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadJobcards();
  },
  computed: {
    ...mapGetters(["systemJobcards"]),
  },
  methods: {
    ...mapActions([
      "loadJobcards",
      "viewJobcard",
      "addJoblabour",
      "viewjobcardsales",
    ]),
  },
};
</script>


// WEBPACK FOOTER //
// src/sales/managejobcardsales.vue